import React from 'react';
import { CheckIcon } from 'lucide-react';
import { systemChecklist, BOX_IMAGE, PURCHASE_ANCHOR } from '../data/content';
export function SystemOverview() {
  return <section className="bg-white px-4 py-6 sm:px-6" data-id="element-143" data-mp="18tg25oet4yhn">
      <div className="mx-auto max-w-2xl text-center" data-id="element-144" data-mp="1mlch0qrgtbw3">
        <h2 className="font-heading text-lg font-extrabold uppercase leading-tight text-petrol sm:text-2xl" data-id="element-145" data-mp="1hnknxtf33jqb">
          The Complete 6-in-1 Care Organization System
        </h2>
        <p className="mt-1 font-heading text-xl font-extrabold uppercase text-deep sm:text-3xl" data-id="element-146" data-mp="u02ultg68dl8">
          💙 CAREGIVER READY™
        </p>
        <p className="mt-1 font-heading text-xs font-semibold uppercase tracking-wide text-sage sm:text-sm" data-id="element-147" data-mp="13wpeaewrgylo">
          Ready-to-use resources for professional caregivers
        </p>
        <p className="mt-1 text-xs font-medium text-deep/80 sm:text-sm" data-id="element-148" data-mp="2fbcrr68ndj6v">
          Daily Planning • Personal Care • Meals &amp; Hydration • Mobility &amp;
          Safety • Care Notes • Handoffs
        </p>

        <a href={PURCHASE_ANCHOR} className="mt-3 block" data-id="element-149" data-mp="236mfceqf8yw5">
          <img src={BOX_IMAGE} alt="The six modules of the CAREGIVER READY™ system" className="mx-auto w-full max-w-[280px] sm:max-w-sm" data-id="element-150" data-mp="2364a4sls7ac3" />
        </a>

        <ul className="mt-3 grid grid-cols-1 gap-x-4 gap-y-1.5 text-left sm:grid-cols-2" data-id="element-151" data-mp="2d5bnhfsin4z7">
          {systemChecklist.map(item => <li key={item} className="flex items-start gap-2" data-id="element-152" data-mp="1kg4rangjarh4">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" strokeWidth={3} data-id="element-153" data-mp="1khpka8n7a2cv" />
              <span className="text-sm leading-snug sm:text-base" data-id="element-154" data-mp="1uec5iyjfuvff">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}